'use client';

import Link from 'next/link';
import Image from 'next/image';

export default function AboutHero() {
  return (
    <div className="w-full py-10 md:py-16 mt-20 bg-white">
      {/* Container with background image - 80% width on desktop, 90% on mobile */}
      <div className="w-[90%] md:w-[80%] mx-auto relative overflow-hidden rounded-3xl h-[350px] md:min-h-[720px]">
        {/* Background image with arrows pattern */}
        <div className="absolute inset-0 z-0">
          <Image
            src="https://d31bwppm8yl9g2.cloudfront.net/learner/website/abtheron.webp"
            alt="Arrow Pattern Background"
            fill
            className="object-cover"
            priority
          />
        </div>
        
        {/* Content - Using flex to center vertically and horizontally */}
        <div className="absolute inset-0 flex items-center justify-center z-10">
          <div className="flex flex-col items-center justify-center text-center px-6 md:px-10 w-full">
            <h1 className="text-[28px] md:text-[36px] font-medium text-white mb-4 leading-tight">
              Unleashing Potential,<br/>
              Transforming Lives
            </h1>
            
            <p className="text-white text-sm md:text-base max-w-2xl mb-10 leading-relaxed">
              At GrowthSchool, we partner with the top 1% of instructors to create high-impact 
              cohort-based courses on personal and professional growth for learners 
              all over the world.
            </p>
            
            <Link 
              href="https://sisinty.keka.com/careers" 
              className="bg-[#33c375] cursor-pointer hover:bg-[#6AD384] text-[#012726] font-medium px-6 py-3 rounded-md flex items-center transition-all"
            >
              See Job Openings
              <svg className="ml-2" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 5L19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}